/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-10 10:04:46
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-02-25 09:47:15
 */
import React, { useEffect } from 'react' ;
import { CityNotice, CityTitle, CurCityBlock } from '../../component';
import { Link } from 'react-router-dom';
import { getCity } from '../../util/helper' ;
import { Log } from '../../util/empty' ;

const CityPage = () => {
  useEffect(() => {
    let temp = decodeURI(window.location.hash).split(":")[1];
    let city = temp.length > 0 ? temp.split("_")[1] : getCity() ;
    if(city == '乐清') {
      Log('yueqing') ;
    }
  },[]) ;
  return (
    <div className="citypage-block">
      <CityTitle/>
      <CityNotice/>
      <CurCityBlock/>
      <div className="button-goto-index">
        <a href="//hrgnode.58.com/zcm/springpc/#/" target="_blank"></a>
      </div>
      <div className="bottom-logo-block"></div>
    </div>
  )
}

export default CityPage ;